import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { P, fs, radius, ease } from '../theme/tokens';

const Group = styled.div`
  display: flex;
  gap: 4px;
  padding: 3px;
  background: ${P.white};
  border: 1px solid ${P.border};
  border-radius: ${radius.pill}px;
`;

const ViewBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  border: none;
  border-radius: ${radius.pill}px;
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  cursor: pointer;
  background: ${(p) => (p.$active ? P.grad : 'transparent')};
  color: ${(p) => (p.$active ? P.white : P.muted)};
  transition: background 150ms ${ease};

  &:hover:not([aria-pressed='true']) {
    color: ${P.navyInk};
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 2px;
  }
  svg {
    font-size: 11px;
  }
`;

export default function ViewToggle({ views, value, onChange, style }) {
  return (
    <Group role="group" aria-label="View" style={style}>
      {views.map((v) => (
        <ViewBtn key={v.key} type="button" $active={value === v.key} aria-pressed={value === v.key} onClick={() => onChange(v.key)}>
          {v.icon && <FontAwesomeIcon icon={v.icon} />}
          {v.label}
        </ViewBtn>
      ))}
    </Group>
  );
}
